import React from 'react';
import {AppContainer, Spinner, Variants} from "toolbox-react-frontend-components";

const LoadingPane = () => {
    return (
        <AppContainer
            className={'d-flex justify-content-center align-items-center'}
        >
            <Spinner
                variant={Variants.Dark}
            />
        </AppContainer>
    );
}

export default LoadingPane;
